import { formatDate } from 'services/date';

const ENCOUNTER_EVENT_START_DATE_FORMAT = 'DD/MMM/YYYY, hh:mm A';

export function getEventStartDate(date, currentStudy) {
  if (currentStudy?.timeZoneValid) {
    const { timeZone: tz } = currentStudy;
    return formatDate(date, ENCOUNTER_EVENT_START_DATE_FORMAT, { tz, tzShow: true });
  }
  return formatDate(date, ENCOUNTER_EVENT_START_DATE_FORMAT);
}
